Hop.defineModule('link', (root) => {
    const $root = $(root);

    let ctrlActive = false;

    Hop.$doc.keydown((event) => {
        if (event.which === 17 || event.which === 91) {
            ctrlActive = true;
        }
    });

    Hop.$doc.keyup(() => {
        ctrlActive = false;
    });

    function isCasualLink(target) {
        return target.nodeName === 'A' && target.getAttribute('data-link') === null;
    }

    function userWantsANewTab(e) {
        return ctrlActive || e.which === 2;
    }

    function userWantToBeRedirected(e) {
        // verify user didn't press right click or left click on mouseup event
        return e.type === 'click' ? e.which !== 3 && e.which !== 2 : e.which === 2;
    }

    function gaEventOnClick(link) {
        return link.getAttribute('data-ga-event') !== null && link.getAttribute('data-ga-event') !== undefined;
    }

    function redirectToTarget(link) {
        window.location.href = link.getAttribute('data-link');
    }

    function redirectToTargetInNewTab(link) {
        window.open(link.getAttribute('data-link'));
    }

    function sendGaEvent(link) {
        const cfg = JSON.parse(link.getAttribute('data-ga-event'));
        Hop.safeGA('send', 'event', cfg.category, cfg.action, cfg.label);
    }

    function linkClickCallback(e, link) {
        if (gaEventOnClick(link)) {
            sendGaEvent(link);
        }

        if (userWantsANewTab(e)) {
            redirectToTargetInNewTab(link);
        } else {
            redirectToTarget(link);
        }
    }

    $root.on('click , mouseup', '[data-link]', function (e) {
        if (!isCasualLink(e.target)) {
            e.preventDefault();
            if (userWantToBeRedirected(e)) {
                // eslint-disable-next-line no-invalid-this
                linkClickCallback(e, this);
            }
        }
    });
});
